export const commonBanks = {
    'amex': 'american express',
    'mc': 'mastercard',
    'u.s. bank': 'us bank',
    'boa': 'bank of america',
    "well's fargo": 'wells fargo',
}
